export const FETCH_TIMELINE = "FETCH_TIMELINE";
export const FETCH_TIMELINE_FAIL = "FETCH_TIMELINE_FAIL";
export const FETCH_TIMELINE_SUCCESS = "FETCH_TIMELINE_SUCCESS";

export const SET_CHAPTER_STEP = "SET_CHAPTER_STEP";
export const SET_CHAPTER_STEP_FAIL = "SET_CHAPTER_STEP_FAIL";
export const SET_CHAPTER_STEP_SUCCESS = "SET_CHAPTER_STEP_SUCCESS";

export const SET_CHAPTER_SLIDE_STEP = "SET_CHAPTER_SLIDE_STEP";
export const SET_CHAPTER_SLIDE_STEP_FAIL = "SET_CHAPTER_SLIDE_STEP_FAIL";
export const SET_CHAPTER_SLIDE_STEP_SUCCESS = "SET_CHAPTER_SLIDE_STEP_SUCCESS";

export const SET_CURRENT_CHAPTER = "SET_CURRENT_CHAPTER";
export const SET_CURRENT_CHAPTER_FAIL = "SET_CURRENT_CHAPTER_FAIL";
export const SET_CURRENT_CHAPTER_SUCCESS = "SET_CURRENT_CHAPTER_SUCCESS";
